/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/const/MediaTypes.ts
 * @create:      2025-07-03 17:18:53.311
 * @modify:      2025-07-11 21:19:12.917
 * @version:     6.0.0
 * @times:       12
 * @lines:       673
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { IMediaType } from "../interface/IMediaType";

/**
 * AAC audio
 */
export const MediaTypes_AAC: IMediaType = {
    type: "audio/aac",
    extension: ".aac",
    name: "AAC audio",
};

/**
 * AbiWord document
 */
export const MediaTypes_ABW: IMediaType = {
    type: "application/x-abiword",
    extension: ".abw",
    name: "AbiWord document",
};

/**
 * Archive document (multiple files embedded)
 */
export const MediaTypes_ARC: IMediaType = {
    type: "application/octet-stream",
    extension: ".arc",
    name: "Archive document (multiple files embedded)",
};

/**
 * AVI: Audio Video Interleave
 */
export const MediaTypes_AVI: IMediaType = {
    type: "video/x-msvideo",
    extension: ".avi",
    name: "AVI: Audio Video Interleave",
};

/**
 * Amazon Kindle eBook format
 */
export const MediaTypes_AZW: IMediaType = {
    type: "application/vnd.amazon.ebook",
    extension: ".azw",
    name: "Amazon Kindle eBook format",
};

/**
 * Any kind of binary data
 */
export const MediaTypes_BIN: IMediaType = {
    type: "application/octet-stream",
    extension: ".bin",
    name: "Any kind of binary data",
};

/**
 * Windows OS/2 Bitmap Graphics
 */
export const MediaTypes_BMP: IMediaType = {
    type: "image/bmp",
    extension: ".bmp",
    name: "Windows OS/2 Bitmap Graphics",
};

/**
 * BZip archive
 */
export const MediaTypes_BZ: IMediaType = {
    type: "application/x-bzip",
    extension: ".bz",
    name: "BZip archive",
};

/**
 * BZip2 archive
 */
export const MediaTypes_BZ2: IMediaType = {
    type: "application/x-bzip2",
    extension: ".bz2",
    name: "BZip2 archive",
};

/**
 * C-Shell script
 */
export const MediaTypes_CSH: IMediaType = {
    type: "application/x-csh",
    extension: ".csh",
    name: "C-Shell script",
};

/**
 * Cascading Style Sheets (CSS)
 */
export const MediaTypes_CSS: IMediaType = {
    type: "text/css",
    extension: ".css",
    name: "Cascading Style Sheets (CSS)",
};

/**
 * Comma-separated values (CSV)
 */
export const MediaTypes_CSV: IMediaType = {
    type: "text/csv",
    extension: ".csv",
    name: "Comma-separated values (CSV)",
};

/**
 * Microsoft Word
 */
export const MediaTypes_DOC: IMediaType = {
    type: "application/msword",
    extension: ".doc",
    name: "Microsoft Word",
};

/**
 * Microsoft Word (OpenXML)
 */
export const MediaTypes_DOCX: IMediaType = {
    type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    extension: ".docx",
    name: "Microsoft Word (OpenXML)",
};

/**
 * MS Embedded OpenType fonts
 */
export const MediaTypes_EOT: IMediaType = {
    type: "application/vnd.ms-fontobject",
    extension: ".eot",
    name: "MS Embedded OpenType fonts",
};

/**
 * Electronic publication (EPUB)
 */
export const MediaTypes_EPUB: IMediaType = {
    type: "application/epub+zip",
    extension: ".epub",
    name: "Electronic publication (EPUB)",
};

/**
 * ECMAScript (IANA Specification) (RFC 4329 Section 8.2)
 */
export const MediaTypes_ES: IMediaType = {
    type: "application/ecmascript",
    extension: ".es",
    name: "ECMAScript (IANA Specification) (RFC 4329 Section 8.2)",
};

/**
 * Graphics Interchange Format (GIF)
 */
export const MediaTypes_GIF: IMediaType = {
    type: "image/gif",
    extension: ".gif",
    name: "Graphics Interchange Format (GIF)",
};

/**
 * HyperText Markup Language (HTML)
 */
export const MediaTypes_HTM: IMediaType = {
    type: "text/html",
    extension: ".htm",
    name: "HyperText Markup Language (HTML)",
};

/**
 * HyperText Markup Language (HTML)
 */
export const MediaTypes_HTML: IMediaType = {
    type: "text/html",
    extension: ".html",
    name: "HyperText Markup Language (HTML)",
};

/**
 * Icon format
 */
export const MediaTypes_ICO: IMediaType = {
    type: "image/x-icon",
    extension: ".ico",
    name: "Icon format",
};

/**
 * iCalendar format
 */
export const MediaTypes_ICS: IMediaType = {
    type: "text/calendar",
    extension: ".ics",
    name: "iCalendar format",
};

/**
 * Java Archive (JAR)
 */
export const MediaTypes_JAR: IMediaType = {
    type: "application/java-archive",
    extension: ".jar",
    name: "Java Archive (JAR)",
};

/**
 * JPEG images
 */
export const MediaTypes_JPEG: IMediaType = {
    type: "image/jpeg",
    extension: ".jpeg",
    name: "JPEG images",
};

/**
 * JPEG images
 */
export const MediaTypes_JPG: IMediaType = {
    type: "image/jpeg",
    extension: ".jpg",
    name: "JPEG images",
};

/**
 * JavaScript (IANA Specification) (RFC 4329 Section 8.2)
 */
export const MediaTypes_JS: IMediaType = {
    type: "application/javascript",
    extension: ".js",
    name: "JavaScript (IANA Specification) (RFC 4329 Section 8.2)",
};

/**
 * JSON format
 */
export const MediaTypes_JSON: IMediaType = {
    type: "application/json",
    extension: ".json",
    name: "JSON format",
};

/**
 * Musical Instrument Digital Interface (MIDI)
 */
export const MediaTypes_MID: IMediaType = {
    type: "audio/midi audio/x-midi",
    extension: ".mid",
    name: "Musical Instrument Digital Interface (MIDI)",
};

/**
 * Musical Instrument Digital Interface (MIDI)
 */
export const MediaTypes_MIDI: IMediaType = {
    type: "audio/midi audio/x-midi",
    extension: ".midi",
    name: "Musical Instrument Digital Interface (MIDI)",
};

/**
 * MPEG Video
 */
export const MediaTypes_MPEG: IMediaType = {
    type: "video/mpeg",
    extension: ".mpeg",
    name: "MPEG Video",
};

/**
 * Apple Installer Package
 */
export const MediaTypes_MPKG: IMediaType = {
    type: "application/vnd.apple.installer+xml",
    extension: ".mpkg",
    name: "Apple Installer Package",
};

/**
 * OpenDocument presentation document
 */
export const MediaTypes_ODP: IMediaType = {
    type: "application/vnd.oasis.opendocument.presentation",
    extension: ".odp",
    name: "OpenDocument presentation document",
};

/**
 * OpenDocument spreadsheet document
 */
export const MediaTypes_ODS: IMediaType = {
    type: "application/vnd.oasis.opendocument.spreadsheet",
    extension: ".ods",
    name: "OpenDocument spreadsheet document",
};

/**
 * OpenDocument text document
 */
export const MediaTypes_ODT: IMediaType = {
    type: "application/vnd.oasis.opendocument.text",
    extension: ".odt",
    name: "OpenDocument text document",
};

/**
 * OGG audio
 */
export const MediaTypes_OGA: IMediaType = {
    type: "audio/ogg",
    extension: ".oga",
    name: "OGG audio",
};

/**
 * OGG video
 */
export const MediaTypes_OGV: IMediaType = {
    type: "video/ogg",
    extension: ".ogv",
    name: "OGG video",
};

/**
 * OGG
 */
export const MediaTypes_OGX: IMediaType = {
    type: "application/ogg",
    extension: ".ogx",
    name: "OGG",
};

/**
 * OpenType font
 */
export const MediaTypes_OTF: IMediaType = {
    type: "font/otf",
    extension: ".otf",
    name: "OpenType font",
};

/**
 * Portable Network Graphics
 */
export const MediaTypes_PNG: IMediaType = {
    type: "image/png",
    extension: ".png",
    name: "Portable Network Graphics",
};

/**
 * Adobe Portable Document Format (PDF)
 */
export const MediaTypes_PDF: IMediaType = {
    type: "application/pdf",
    extension: ".pdf",
    name: "Adobe Portable Document Format (PDF)",
};

/**
 * Microsoft PowerPoint
 */
export const MediaTypes_PPT: IMediaType = {
    type: "application/vnd.ms-powerpoint",
    extension: ".ppt",
    name: "Microsoft PowerPoint",
};

/**
 * Microsoft PowerPoint (OpenXML)
 */
export const MediaTypes_PPTX: IMediaType = {
    type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    extension: ".pptx",
    name: "Microsoft PowerPoint (OpenXML)",
};

/**
 * RAR archive
 */
export const MediaTypes_RAR: IMediaType = {
    type: "application/x-rar-compressed",
    extension: ".rar",
    name: "RAR archive",
};

/**
 * Rich Text Format (RTF)
 */
export const MediaTypes_RTF: IMediaType = {
    type: "application/rtf",
    extension: ".rtf",
    name: "Rich Text Format (RTF)",
};

/**
 * Bourne shell script
 */
export const MediaTypes_SH: IMediaType = {
    type: "application/x-sh",
    extension: ".sh",
    name: "Bourne shell script",
};

/**
 * Scalable Vector Graphics (SVG)
 */
export const MediaTypes_SVG: IMediaType = {
    type: "image/svg+xml",
    extension: ".svg",
    name: "Scalable Vector Graphics (SVG)",
};

/**
 * Small web format (SWF) or Adobe Flash document
 */
export const MediaTypes_SWF: IMediaType = {
    type: "application/x-shockwave-flash",
    extension: ".swf",
    name: "Small web format (SWF) or Adobe Flash document",
};

/**
 * Tape Archive (TAR)
 */
export const MediaTypes_TAR: IMediaType = {
    type: "application/x-tar",
    extension: ".tar",
    name: "Tape Archive (TAR)",
};

/**
 * Tagged Image File Format (TIFF)
 */
export const MediaTypes_TIF: IMediaType = {
    type: "image/tiff",
    extension: ".tif",
    name: "Tagged Image File Format (TIFF)",
};

/**
 * Tagged Image File Format (TIFF)
 */
export const MediaTypes_TIFF: IMediaType = {
    type: "image/tiff",
    extension: ".tiff",
    name: "Tagged Image File Format (TIFF)",
};

/**
 * Typescript file
 */
export const MediaTypes_TS: IMediaType = {
    type: "application/typescript",
    extension: ".ts",
    name: "Typescript file",
};

/**
 * TrueType Font
 */
export const MediaTypes_TTF: IMediaType = {
    type: "font/ttf",
    extension: ".ttf",
    name: "TrueType Font",
};

/**
 * Text
 */
export const MediaTypes_TXT: IMediaType = {
    type: "text/plain",
    extension: ".txt",
    name: "Text",
};

/**
 * Microsoft Visio
 */
export const MediaTypes_VSD: IMediaType = {
    type: "application/vnd.visio",
    extension: ".vsd",
    name: "Microsoft Visio",
};

/**
 * Waveform Audio Format
 */
export const MediaTypes_WAV: IMediaType = {
    type: "audio/wav",
    extension: ".wav",
    name: "Waveform Audio Format",
};

/**
 * WEBM audio
 */
export const MediaTypes_WEBA: IMediaType = {
    type: "audio/webm",
    extension: ".weba",
    name: "WEBM audio",
};

/**
 * WEBM video
 */
export const MediaTypes_WEBM: IMediaType = {
    type: "video/webm",
    extension: ".webm",
    name: "WEBM video",
};

/**
 * WEBP image
 */
export const MediaTypes_WEBP: IMediaType = {
    type: "image/webp",
    extension: ".webp",
    name: "WEBP image",
};

/**
 * Web Open Font Format (WOFF)
 */
export const MediaTypes_WOFF: IMediaType = {
    type: "font/woff",
    extension: ".woff",
    name: "Web Open Font Format (WOFF)",
};

/**
 * Web Open Font Format (WOFF)
 */
export const MediaTypes_WOFF2: IMediaType = {
    type: "font/woff2",
    extension: ".woff2",
    name: "Web Open Font Format (WOFF)",
};

/**
 * XHTML
 */
export const MediaTypes_XHTML: IMediaType = {
    type: "application/xhtml+xml",
    extension: ".xhtml",
    name: "XHTML",
};

/**
 * Microsoft Excel
 */
export const MediaTypes_XLS: IMediaType = {
    type: "application/vnd.ms-excel",
    extension: ".xls",
    name: "Microsoft Excel",
};

/**
 * Microsoft Excel (OpenXML)
 */
export const MediaTypes_XLSX: IMediaType = {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    extension: ".xlsx",
    name: "Microsoft Excel (OpenXML)",
};

/**
 * XML
 */
export const MediaTypes_XML: IMediaType = {
    type: "application/xml",
    extension: ".xml",
    name: "XML",
};

/**
 * XUL
 */
export const MediaTypes_XUL: IMediaType = {
    type: "application/vnd.mozilla.xul+xml",
    extension: ".xul",
    name: "XUL",
};

/**
 * ZIP archive
 */
export const MediaTypes_ZIP: IMediaType = {
    type: "application/zip",
    extension: ".zip",
    name: "ZIP archive",
};

/**
 * 3GPP audio container
 */
export const MediaTypes_3GP_AUDIO: IMediaType = {
    type: "audio/3gpp",
    extension: ".3gp",
    name: "3GPP audio container",
};

/**
 * 3GPP video container
 */
export const MediaTypes_3GP_VIDEO: IMediaType = {
    type: "video/3gpp",
    extension: ".3gp",
    name: "3GPP video container",
};

/**
 * 3GPP2 audio container
 */
export const MediaTypes_3G2_AUDIO: IMediaType = {
    type: "audio/3gpp2",
    extension: ".3g2",
    name: "3GPP audio container",
};

/**
 * 3GPP2 video container
 */
export const MediaTypes_3G2_VIDEO: IMediaType = {
    type: "video/3gpp2",
    extension: ".3g2",
    name: "3GPP video container",
};

/**
 * 7-zip archive
 */
export const MediaTypes_7Z: IMediaType = {
    type: "application/x-7z-compressed",
    extension: ".7z",
    name: "7-zip archive",
};
